import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { MappingCategoryT } from 'routes/Mappings/types';
import type { HttpError } from 'store/APIClient';
import { RQAPICallWithData } from 'store/APIClient';

/**
 * Hook to fetch the mapping categories.
 */
export const useAPIGetCategories = (): UseQueryResult<
    MappingCategoryT[],
    HttpError
> =>
    useQuery({
        queryKey: ['mappingsCategories'],
        queryFn: async () => {
            const response = await RQAPICallWithData<MappingCategoryT[]>({
                endpoint: 'mappings/categories',
                method: 'GET',
            });
            return response.content.data;
        },
        meta: { useGlobalOnError: true },
    });
